var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTickGreyIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3220",
    "data-name": "Rectangle 3220",
    width: 8,
    height: 6,
    fill: "#fff"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_14204",
    "data-name": "Group 14204",
    transform: "translate(-96 -255)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_73",
    "data-name": "Ellipse 73",
    cx: 8,
    cy: 8,
    r: 8,
    transform: "translate(96 255)",
    fill: "#dcdcdc"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_13982",
    "data-name": "Group 13982",
    transform: "translate(-987 -323)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_13896",
    "data-name": "Group 13896",
    transform: "translate(1087 583)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_13895",
    "data-name": "Group 13895",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_13140",
    "data-name": "Path 13140",
    d: "M2.483,6a.675.675,0,0,1-.474-.19L.2,4.053a.638.638,0,0,1,0-.919.685.685,0,0,1,.948,0l1.34,1.3L6.857.19A.685.685,0,0,1,7.8.19a.637.637,0,0,1,0,.918L2.956,5.81A.681.681,0,0,1,2.483,6",
    transform: "translate(0)",
    fill: "#fff"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTickGreyIcon);
export default __webpack_public_path__ + "static/media/tickGreyIcon.8ce557269aeddff24833df9438134174.svg";
export { ForwardRef as ReactComponent };